export default __webpack_public_path__ + "static/media/small-sprinter.64760fc6.jpg";